var RESET_PARENT_HTML_ATTRIBUTE = "consent-cb-reset-parent";
var RESET_PARENT_HTML_ATTRIBUTE_VALUE = "1";
var KNOWN_RATIO_CLASSES = {
  // Elementor
  asSuffix: "-fit-aspect-ratio",
  // Gutenberg
  gutenberg: "wp-block-embed__wrapper"
};

function applyContentBlockRatioCssPlainCss() {
  var element = document.createElement("style");
  element.style.type = "text/css";
  document.getElementsByTagName("head")[0].appendChild(element);
  element.innerHTML = ".wp-block-embed__wrapper[".concat(RESET_PARENT_HTML_ATTRIBUTE, "=\"").concat(RESET_PARENT_HTML_ATTRIBUTE_VALUE, "\"]::before {padding-top: 0!important;}");
}

export { applyContentBlockRatioCssPlainCss, RESET_PARENT_HTML_ATTRIBUTE, RESET_PARENT_HTML_ATTRIBUTE_VALUE, KNOWN_RATIO_CLASSES };